import React from 'react';
import ReactDOM from 'react-dom';
import * as serviceWorker from 'utils/service-worker';
import App from 'components/app';

// Render main component
ReactDOM.render(<App />, document.getElementById('root'));

// Disable Caching
serviceWorker.unregister();